import store from '../store'
import { createWt, addSteps } from './wt'

export const tour = createWt()

const steps = [
    {
        serviceCode: 'emka',
        data: [
            {
                id: 1,
                title: 'Świetnie!',
                text:
                    'Aktywowałeś usługę „Aplikacja Moje Sklepy”. Twój sklep pojawi się w aplikacji w przeciągu 24 godzin.',
                attachTo: {
                    element: false,
                    on: 'auto'
                }
            },
            {
                id: 2,
                title: 'Skaner',
                text:
                    'Pamiętaj, aby zweryfikować, czy Twój skaner jest w stanie skanować karty z ekranu telefonu. Zapoznaj się z instrukcją zamieszczoną w zakładce Pomoc w sekcji „Instrukcje do pobrania”.',
                attachTo: {
                    element: false,
                    on: 'auto'
                },
                actionNext: () => {
                    store.dispatch('toggleModal', false)
                    tour.complete()
                }
            }
        ]
    },
    {
        serviceCode: 'shop_api',
        data: [
            {
                id: 1,
                title: 'Świetnie!',
                text: 'Aktywowałeś usługę "Integracji z systemem zapleczowym"',
                attachTo: {
                    element: false,
                    on: 'auto'
                }
            },
            {
                id: 2,
                title: 'Kontakt z serwisantem',
                text:
                    'Umów się na konfigurację oprogramowania z serwisantem systemu magazynowo-sprzedażowego',
                attachTo: {
                    element: false,
                    on: 'auto'
                }
            },
            {
                id: 3,
                title: 'Prawidłowa konfiguracja',
                text:
                    'Po pomyślnej konfiguracji możesz cieszyć się korzyściami, które gwarantuje integracja z systemem zapleczowym!',
                attachTo: {
                    element: false,
                    on: 'auto'
                },
                actionNext: () => {
                    store.dispatch('toggleModal', false)
                    tour.complete()
                }
            }
        ]
    }
]

tour.on('start', function() {
    tour.steps = []
    let filterSteps = []
    const service = steps.find(
        el => el.serviceCode === store.getters.getWalkthroughServiceCode
    )
    if (!service) {
        return
    }
    filterSteps = service.data
    addSteps(tour, filterSteps)
    document.body.classList.add('walkthrough')
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'auto'
})

tour.on('show', function() {
    document.body.classList.add('walkthrough')
    store.dispatch('setWalkthroughActive', true)
})

const cancelEvents = ['close', 'cancel', 'complete']
cancelEvents.forEach(event => {
    return tour.on(event, () => {
        document.body.classList.remove('walkthrough')
        document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth'
        store.dispatch('setWalkthroughActive', false)
        window.scrollTo(0, 0)
        store.dispatch('setWalkthroughServiceCode', null)
    })
})

const closeEvents = ['cancel']
closeEvents.forEach(event =>
    tour.on(event, () => {
        store.dispatch('toggleModal', false)
        store.dispatch(' setWalkthroughServiceCode', null)
    })
)
